// extracted by mini-css-extract-plugin
export default {"formField":"InputWrap_formField__bz1QN","error":"InputWrap_error__MljAQ","label":"InputWrap_label__fc7ol","inputWrap":"InputWrap_inputWrap__67FtT","footer":"InputWrap_footer__CXQSO"};